import React from "react";
import { Home, Monday, Tuesday, Wednesday, Thursday, Friday } from "./days";
import { Switch, Route } from "react-router-dom";

export const Allroutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/monday" component={Monday} />
      <Route path="/tuesday" component={Tuesday} />
      <Route path="/wednesday" component={Wednesday} />
      <Route path="/thursday" component={Thursday} />
      <Route path="/friday" component={Friday} />
    </Switch>
  );
};
